module.exports = __webpack_public_path__ + "img/rheometer.588d9c5d.jpg";